import React from 'react';

import { FlexContainer, Title, Image } from '../common/StyledComponents';

import placeholderImg from '../../assets/coffee.jpg';
import create from '../../assets/create.png';
import learn from '../../assets/learn.png';
import play from '../../assets/play.png';

const backgroundUrl = `url(${placeholderImg})`;

const openings = [
  {
    subject: 'Content Writer',
    designation: 'Hiring Content Writers to write cool stuff about tech',
    description:
      'Beebom’s HR ain’t no Sgt. Fury but, our focus is to Assembling an in-house team of talented geeks who can write quality tech resources for our ever growing reader base.'
  },
  {
    subject: 'Backend Developer',
    designation: 'Hiring Backend Developer to Create a Hard ass Platform',
    description:
      'Beebom’s HR ain’t no Morpheus but, Our focus is to search an engineer as talented  like Neo who has good knowledge of backend, enough experience with building APIs, and decent understanding of Servers, because the next generation deals platform that we’re building requires all of that.'
  },
  {
    subject: 'Graphic Designer',
    designation:
      'Hiring Motion Graphic Designers who can create some High Quality stuff.',
    description:
      'You will be producing high quality premium videos from raw video footage, photos, typography, and creative transitions which can later be made available to our audience on social media.'
  },
  {
    subject: 'Wordpress Developer',
    designation:
      'Hiring WordPress Developer  who can create plugins and manage site  ',
    description:
      'You will be responsible for continuous improvement of the site, development of our own plugins rather than having to rely on 3rd party plugins. Exciting? We know'
  }
];

const Careers = () => {
  window.scrollTo(0, 0);

  const hiring = openings.map((opening, index) => {
    if (index % 2 === 0) {
      return (
        <FlexContainer
          key={opening.designation}
          className="justify-center w-100"
          background="#313131"
        >
          <FlexContainer
            className="flex-column items-center pv3 pv5-ns ph2"
            maxwidth="950px"
          >
            <FlexContainer className="items-center">
              <Title
                className="mb1 mb2-ns"
                fontFamily="Montserrat"
                fontSize="2rem"
                fontWeight="bold"
                fontstyle="italic"
                lineHeight="1.15"
                color="#fff"
              >
                {opening.designation}
              </Title>

              <FlexContainer
                className="ph2 ph3-ns justify-center items-center grow  mh4"
                style={{
                  borderRadius: '20px',
                  width: '101.4px',
                  height: '30.6px',
                  backgroundImage:
                    'linear-gradient(to bottom, #84d9f7, #4db2ec)'
                }}
              >
                <a
                  href={`mailto:careers@beebom.com?
                  &subject=Application for ${opening.subject}`}
                >
                  <Title
                    fontFamily="Montserrat"
                    fontWeight="600"
                    fontSize="0.8625rem"
                    color="#fff"
                  >
                    Apply
                  </Title>
                </a>
              </FlexContainer>
            </FlexContainer>
            <Title
              className="mv2 mv3-ns"
              fontFamily="Montserrat"
              fontSize="1.2rem"
              // fontWeight="600"
              fontstyle="italic"
              color="#fff"
            >
              {opening.description}
            </Title>
          </FlexContainer>
        </FlexContainer>
      );
    } else {
      return (
        <FlexContainer
          key={opening.designation}
          className="justify-center w-100"
          background="#212121"
        >
          <FlexContainer
            className="flex-column items-center pv3 pv5-ns ph2"
            maxwidth="950px"
          >
            <FlexContainer className="items-center">
              <Title
                className="mb1 mb2-ns"
                fontFamily="Montserrat"
                fontSize="2rem"
                fontWeight="bold"
                fontstyle="italic"
                lineHeight="1.15"
                color="#fff"
              >
                {opening.designation}
              </Title>
              <FlexContainer
                className="ph2 ph3-ns justify-center items-center grow mh4"
                style={{
                  borderRadius: '20px',
                  width: '101.4px',
                  height: '30.6px',
                  backgroundImage:
                    'linear-gradient(to bottom, #84d9f7, #4db2ec)'
                }}
              >
                <a
                  href={`mailto:careers@beebom.com?
                  &subject=Application for ${opening.subject}`}
                >
                  <Title
                    fontFamily="Montserrat"
                    fontWeight="600"
                    fontSize="0.8625rem"
                    color="#fff"
                  >
                    Apply
                  </Title>
                </a>
              </FlexContainer>
            </FlexContainer>
            <Title
              className="mv2 mv3-ns"
              fontFamily="Montserrat"
              fontSize="1.2rem"
              // fontWeight="600"
              fontstyle="italic"
              color="#fff"
            >
              {opening.description}
            </Title>
          </FlexContainer>
        </FlexContainer>
      );
    }
  });

  return (
    <div className="w-100">
      <FlexContainer
        className="vh-75 vh-50-ns justify-center items-center bg-center cover"
        background={backgroundUrl}
        style={{ backgroundAttachment: 'fixed' }}
      >
        <FlexContainer maxwidth="950px">
          <Title
            // className="pa3 pa4-m pa5-l"
            className="pa3 pa4-ns"
            fontFamily="Montserrat"
            fontWeight="bold"
            fontstyle="italic"
            fontSize="4.5rem"
            // color="#4db2ec"
            color="#fff"
          >
            Creating a world for tech enthusiasts
          </Title>
        </FlexContainer>
      </FlexContainer>

      <FlexContainer background="#f3f4f6" justifycontent="center">
        <FlexContainer maxwidth="950px" direction="column">
          <Title
            className="ph3 ph4-ns pv3 pb4-ns pt5-ns b tc"
            fontFamily="Nunito"
            fontSize="2.25rem"
            color="#4a4a4a"
          >
            Our Story
          </Title>
          <Title
            className="ph3 ph4-ns pb3 pb5-ns tj"
            fontFamily="Nunito"
            fontSize="1.5rem"
            lineHeight="2rem"
            color="#424242"
          >
            Founded in 2011 (then called thetecnica) as an effort, turned into a
            passion and later into a responsibility to help people use
            technology in the most efficient way possible. If you want to read
            our story of how we scaled ourselves from nothing to a leading (and
            responsible) technology website, read our coverage on YourStory.
            <br />
            <br />
            As per current stats, Beebom is catering to more than 20 million
            monthly users combined at all our platforms and growing rapidly. Our
            audience consists of end consumers of technology, geeks, early
            adopters and influencers.
          </Title>
        </FlexContainer>
      </FlexContainer>

      <FlexContainer
        className="vh-75 vh-50-ns justify-center items-center bg-center cover"
        background={backgroundUrl}
      >
        <FlexContainer maxwidth="950px">
          <Title
            // className="pa3 pa4-m pa5-l"
            className="pa3 pa4-ns"
            fontFamily="Montserrat"
            fontstyle="italic"
            fontWeight="bold"
            fontSize="16rem"
            color="#fff"
          >
            "
          </Title>
          <Title
            // className="pa3 pa4-m pa5-l"
            className="pa3 pa4-ns flex items-center"
            fontFamily="Montserrat"
            lineHeight="1.3"
            // fontWeight="bold"
            fontSize="2.2rem"
            color="#fff"
          >
            WE ARE ON A MISSION TO TOUCH EVERY TECH CONSUMER’S LIFE BY HELPING
            THEM DO MORE WITH THEIR DEVICES.
          </Title>
        </FlexContainer>
      </FlexContainer>

      <FlexContainer background="#f3f4f6" justifycontent="center">
        <FlexContainer maxwidth="950px" direction="column">
          <FlexContainer className="flex-column">
            <Title
              className="ph3 ph4-ns pt5 pt6-ns"
              fontFamily="Montserrat"
              fontSize="2.4rem"
              color="#4db2ec"
            >
              Choose a Job You Love, and You Will Never Have To Work a Day in
              Your Life.
            </Title>
            <Title
              className="ph3 ph4-ns pb3 pb4-ns flex justify-end"
              fontFamily="Montserrat"
              fontSize="1.5rem"
              // lineHeight="2.38rem"
              color="#4db2ec"
            >
              - Confucius
            </Title>
          </FlexContainer>
          <FlexContainer className="pv4 pt5-ns pb6-ns justify-center items-center">
            <FlexContainer
              className="flex-column justify-center items-center w-100 tc"
              style={{ maxWidth: '300px' }}
            >
              <Image src={create} alt="create" width="202px" height="143px" />
              <Title
                className="pt3 pt4-ns b ttu"
                fontFamily="Nunito"
                fontSize="1.5rem"
                lineHeight="1.25"
                color="#252525"
              >
                Create
              </Title>
              <Title
                className="pt2 pt3-ns ph3"
                fontFamily="Montserrat"
                fontSize="1rem"
                lineHeight="1.25"
                color="#3c3c3c"
              >
                We build the best experience for our community - as a team.
              </Title>
            </FlexContainer>
            <FlexContainer
              className="flex-column justify-center items-center w-100 tc"
              style={{ maxWidth: '300px' }}
            >
              <Image src={learn} alt="create" width="143px" height="125px" />
              <Title
                className="pt3 pt4-ns b ttu"
                fontFamily="Nunito"
                fontSize="1.5rem"
                lineHeight="1.25"
                color="#252525"
              >
                Learn
              </Title>
              <Title
                className="pt2 pt3-ns ph3"
                fontFamily="Montserrat"
                fontSize="1rem"
                lineHeight="1.25"
                color="#3c3c3c"
              >
                We look inside and outside for inspiration and learning.
              </Title>
            </FlexContainer>
            <FlexContainer
              className="flex-column justify-center items-center w-100 tc"
              style={{ maxWidth: '300px' }}
            >
              <Image src={play} alt="create" width="170px" height="159px" />
              <Title
                className="pt3 pt4-ns b ttu"
                fontFamily="Nunito"
                fontSize="1.5rem"
                lineHeight="1.25"
                color="#252525"
              >
                Play
              </Title>
              <Title
                className="pt2 pt3-ns ph3"
                fontFamily="Montserrat"
                fontSize="1rem"
                lineHeight="1.25"
                color="#3c3c3c"
              >
                Life is what happens when you're busy working. We make sure to
                enjoy it.
              </Title>
            </FlexContainer>
          </FlexContainer>
        </FlexContainer>
      </FlexContainer>

      {hiring}

      {/* <FlexContainer
        className="w-100"
        style={{ height: '5px', background: '#4db2ec' }}
      /> */}
    </div>
  );
};

export default Careers;
